import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IEducationSectorPayload, IInitialStateSectors} from "../types";
import {GetDeleteSectors, GetSectors} from "./thunk";



const initialState:IInitialStateSectors = {
    sectors:[],
    sectorsRestore:[],
    filteredSectors:[],
    isLoadingSectors:false,
    isViewSectors:false,
    selectedSectorsIDs:[]
}


const educationalSectorsSlice = createSlice({
    name:"educationalSectors",
    initialState,
    reducers:{
        setSectors: (
            state,
            action: PayloadAction<{ data: IEducationSectorPayload[]; defaultLanguage: string }>
        ) => {
            const {data,defaultLanguage} = action.payload;

            state.sectors = data
            state.filteredSectors = data.flatMap((data) =>
                data.translations
                    .filter((elem) => elem.slug === defaultLanguage)
                    .map((elem) => ({
                        id: data.id,
                        name: elem.name || "Unknown Name",
                    }))
            );
        },

        updateSectors: (state, action: PayloadAction<IEducationSectorPayload>) => {
            const updateData = action.payload;

            state.sectors = state.sectors.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        deletedSectors: (state, action: PayloadAction<number>) => {
            state.sectors = state.sectors.filter(
                (elem) => elem.id !== action.payload
            );

        },
        setSectorsRestore:(state, action) => {
            state.sectorsRestore = action.payload;
        },
        deletedSectorsRestore:(state,action)=>{
            state.sectorsRestore = state.sectorsRestore.filter(
                (elem) => elem.id !== action.payload
            );

        },
        setIsViewSectors:(state)=>{

            state.isViewSectors =!state.isViewSectors;
        },
        setSelectedSectorsIDs: (state, action) => {
            state.selectedSectorsIDs=action.payload
        },


    },
    extraReducers: (builder) => {
        builder
            .addCase(GetSectors.pending, (state) => {
                state.isLoadingSectors = true;
            })
            .addCase(GetSectors.fulfilled, (state) => {
                state.isLoadingSectors = false;
            })
            .addCase(GetSectors.rejected, (state) => {
                state.isLoadingSectors = false;
            })
            .addCase(GetDeleteSectors.pending, (state) => {
                state.isLoadingSectors = true;
            })
            .addCase(GetDeleteSectors.fulfilled, (state) => {
                state.isLoadingSectors = false;
            })
            .addCase(GetDeleteSectors.rejected, (state) => {
                state.isLoadingSectors = false;
            });
    },
})
export const {
    setSectors,
    updateSectors,
    deletedSectors,
    setIsViewSectors,
    setSectorsRestore,
    deletedSectorsRestore,
    setSelectedSectorsIDs,
} = educationalSectorsSlice.actions
export default educationalSectorsSlice